import { addDoc, collection, doc, getDoc, getDocs, query, setDoc, where } from 'firebase/firestore'

import { db } from 'utils/firebase'
import { formatDocSnapshot, formatQuerySnapshot } from 'utils/queries/formatFirestoreResults'

import { Program, ProgramType } from 'types/program'
import { Data } from 'types/query'

export const fetchProgramById = async (programId: string | undefined): Promise<Program | null> => {
  if (!programId) return null
  const programRef = doc(db, 'programs', programId)
  const programDocSnap = await getDoc(programRef)
  return formatDocSnapshot(programDocSnap) as unknown as Program
}

export const fetchProgramsByIds = async (programIds: string[]) => {
  const programPromises = programIds.map((id) => fetchProgramById(id))
  const programs = await Promise.all(programPromises)
  return programs?.filter((p) => p?.type === ProgramType.PROGRAM)
}

export const fetchProgramsByUserId = async (data: Data): Promise<Program[] | null> => {
  const { userId } = data
  if (!userId) return null

  const q = query(
    collection(db, 'programs'),
    where('trainer.id', '==', userId),
    where('type', '==', ProgramType.PROGRAM),
  )

  const querySnapshot = await getDocs(q)
  const results = formatQuerySnapshot(querySnapshot)
  const validResults = results.filter((p) => p?.title !== undefined && p?.title?.length > 0)
  if (validResults.length === 0) return null
  return validResults
}

export const createProgram = async (userId: string | undefined) => {
  if (!userId) return null

  const newProgramRef = await addDoc(collection(db, 'programs'), {
    leaderboard: {},
    trainer: { id: userId },
    type: ProgramType.PROGRAM,
  })

  return newProgramRef?.id
}

export const postProgram = async (data: Data) => {
  if (!data || !data?.programId || !data?.updatedOrCreatedData)
    throw new Error('No data passed into postProgram')

  const { programId, updatedOrCreatedData } = data
  const programRef = doc(db, 'programs', programId)

  const fullData = { ...updatedOrCreatedData, updated: new Date() }
  await setDoc(programRef, fullData, { merge: true })
  return fullData
}
